import { render, staticRenderFns } from "./nutritionAllergenPage.vue?vue&type=template&id=769f3aef&scoped=true"
import script from "./nutritionAllergenPage.vue?vue&type=script&lang=js"
export * from "./nutritionAllergenPage.vue?vue&type=script&lang=js"
import style0 from "./nutritionAllergenPage.vue?vue&type=style&index=0&id=769f3aef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769f3aef",
  null
  
)

export default component.exports